export default __webpack_public_path__ + "static/bariol_serif_bold_italic-webfont-f42d391bead343b3caee585cdc47c7b8.woff";